import React, { useState, useEffect, } from "react";
import { FormattedMessage, useIntl, } from "react-intl";
import { UserSignout, } from '../../services/users';
import { Link, useLocation, useNavigate, } from 'react-router';
import Gravatar from 'react-gravatar';
import { Layout, Menu, Dropdown, Avatar, Button, Alert, } from 'antd';
import notification from '../../services/notification';

import Logo from './../../assets/images/logo_diap.png';
import {
    BankIcon, ChartBarIcon, GearIcon, HandCoinsIcon, ListChecksIcon,
    PowerIcon, ShieldCheckIcon, ShieldSlashIcon, SignOutIcon, SquaresFourIcon,
    TranslateIcon, UsersThreeIcon,
} from "@phosphor-icons/react";

const { Header } = Layout;

const HeaderBar = ({
    auth,
    collapsed,
    setCollapsed,
    ...props
}) => {

    const { pathname } = useLocation();
    const { setCurrentLanguage, locale } = props;
    const localdata = sessionStorage.getItem('authentication');
    const permission = localdata && JSON.parse(localdata).permission;
    const user_mfa_enabled = localdata && JSON.parse(localdata).user_mfa_enabled;
    const LocalStore = JSON.parse(localdata || '{}');
    const [displayLanguageItem, setDisplayLanguageItem] = useState(locale);
    const [mfaWarningClosed, setMfaWarningClosed] = useState(
        sessionStorage.getItem("user_mfa_enabled_warning_closed") === "true"
    );
    const intl = useIntl();
    const history = useNavigate();

    useEffect(() => {
        switch (locale) {
            case "nl":
                setDisplayLanguageItem('en');
                break;
            case "en":
                setDisplayLanguageItem('nl');
                break;
            default:
                setDisplayLanguageItem('nl');
                break;
        };
    }, [locale]);

    const signout = () => {
        const { username, jwt_token } = auth;

        UserSignout({ username: username, access_token: jwt_token }, history)
            .then(response => {
                if (response.status) {
                    history('/login');
                    notification['success']({
                        message: 'Uitloggen',
                        description: intl.formatMessage({ id: response.msg }),
                    });
                }
            })
            .catch(error => {
                console.error('error: ', error);
            });
    };

    const ProfileMenuItems = {
        items: [{
            key: 'profile',
            label: (<Link to="/profile" className="dropdown-itemm">
                <GearIcon size={16} /> <FormattedMessage id="profile-settings" />
            </Link>),
        },
        {
            key: 'system',
            label: permission === "administrators" ? (<Link to="/system" className="dropdown-itemm">
                <GearIcon size={16} /> <FormattedMessage id="profile-system-settings" />
            </Link>) : null,
        },
        {
            key: 'security',
            label: (<Link to="/profile/security" className="dropdown-itemm">
                <ShieldCheckIcon size={16} /> <FormattedMessage id="profile-security" />
            </Link>),
        },
        {
            key: 'divider',
            type: 'divider',
        },
        {
            key: 'logoff',
            label: (<span className="dropdown-ite" data-testid="button_signout" onClick={e => { signout(e) }}><SignOutIcon size={16} /> <FormattedMessage id="profile-signout" /></span>),
        }
        ].filter(Boolean),
    };

    const toggleLanguage = () => {
        switch (locale) {
            case "nl":
                setCurrentLanguage('en');
                break;
            case "en":
                setCurrentLanguage('nl');
                break;
            default:
                break;
        };
    };

    const menuItems = [{
        key: "/dashboard",
        label: (<Link to="/dashboard"><SquaresFourIcon size={16} /> <FormattedMessage id="dashboard" /></Link>),
    },
    {
        key: "/trades",
        label: (<Link to="/trades"><HandCoinsIcon size={16} /> <FormattedMessage id="trades" /></Link>),
    },
    {
        key: "/journals",
        label: (<Link to="/journals"><ListChecksIcon size={16} /> <FormattedMessage id="journals" /></Link>),
    },
    {
        key: "/strategies",
        label: (<Link to="/strategies"><ChartBarIcon size={16} /> <FormattedMessage id="strategies" /></Link>),
    },
    // {
    //     key: "/backtest",
    //     label: (<Link to="/backtest"><FlaskIcon size={16} /> <FormattedMessage id="backtest" /></Link>),
    // },
    // {
    //     key: "/instruments",
    //     label: (<Link to="/instruments"><GearIcon size={16} /> <FormattedMessage id="instruments" /></Link>),
    // },
    {
        key: "/brokers",
        label: (<Link to="/brokers"><BankIcon size={16} /> <FormattedMessage id="brokers" /></Link>),
    },

    // {
    //     key: "/strategy-bots/add",
    //     label: (<Link to="/strategy-bots/add"><ShoppingCartIcon size={16} /> <FormattedMessage id="market-place" /></Link>),
    // },

    // pro trader items
    // ...(["operators", "administrators"].includes(permission) ? [{
    //     key: "/signals",
    //     label: (<Link to="/signals"><BellRingingIcon size={16} /> Manage Signals</Link>),
    // }] : []),

    // administrator items
    ...(permission === "administrators" ? [
        {
            key: "/customers",
            label: (<Link to="/customers"><UsersThreeIcon size={16} /> <FormattedMessage id="customers" /></Link>),
        }] : []),
    {
        key: "language",
        label: (<span onClick={toggleLanguage}><TranslateIcon size={16} /> {displayLanguageItem.toUpperCase()}</span>),

    }];

    const onWarningClose = () => {
        sessionStorage.setItem("user_mfa_enabled_warning_closed", "true");
        setMfaWarningClosed(true);
    };

    return (
        <React.Fragment>
            <Header className="header">
                {auth && (
                    <>
                        <div className="logo">
                            <Link to="/">
                                <img src={Logo} alt="logo" className="header-bar--logo" />
                            </Link>
                        </div>

                        <div className="profile-button">
                            <Dropdown menu={ProfileMenuItems} trigger={['hover']}>
                                <div className="ant-dropdown-link pointer" onClick={e => e.preventDefault()}>
                                    {/* <Avatar size="large" icon={<UserOutlined />} />*/}
                                    <Avatar size="large" icon={<Gravatar email={LocalStore.user_email} default="robohash" className="rounded-full" />} />
                                </div>
                            </Dropdown>
                        </div>

                        <Menu theme="" mode="horizontal"
                            defaultSelectedKeys={[pathname]}
                            items={menuItems}
                        />
                    </>
                )}
            </Header>

            {!user_mfa_enabled &&
                process.env.REACT_APP_STAGE !== "dev" &&
                !mfaWarningClosed && (
                    <div style={{ padding: "10px", color: "#fff", textAlign: "center" }}>
                        <Alert
                            title={<><ShieldSlashIcon size={16} /> <FormattedMessage id="user-mfa-not-enabled" /></>}
                            type="error"
                            closable={{ closeIcon: true, onClose: onWarningClose, 'aria-label': 'close' }}
                            action={<Button size="small" className="ml-2"
                                onClick={() => history('/profile/security')}
                                icon={<PowerIcon size={16} />}>
                                <FormattedMessage id="mfa-enable" />
                            </Button>}
                        />
                    </div>
                )}

        </React.Fragment>
    );
};



export default HeaderBar;